export default function SummaryTabs({
  handleTabClick,
  selectedTab,
}: {
  handleTabClick: (id: string) => void;
  selectedTab: string;
}) {
  const tabs = [
    {
      id: "patient-order-information",
      label: "Patient and order information",
    },
    {
      id: "additional-info",
      label: "Additional Info",
    },
    {
      id: "document-management",
      label: "Document Management",
    },
  ];

  return (
    <div className="sticky top-0 bg-sideNavGray overflow-auto px-3 md:px-5 py-2">
      <div className="flex justify-between md:flex-col ">
        {tabs.map((tab) => (
          <div
            key={tab.id}
            className={`my-1 capitalize cursor-pointer ${
              selectedTab === tab.id
                ? "font-bold text-activeLink hover:font-bold"
                : "text-royalBlue"
            } hover:!text-activeLink md:text-sm text-xs`}
            onClick={() => handleTabClick(tab.id)}
          >
            {tab.label}
          </div>
        ))}
      </div>
    </div>
  );
}
